export default __webpack_public_path__ + "static/media/banner3.70289e56.png";